module.exports = __webpack_public_path__ + "static/p02_back-f0e23f8af78bfab8d881eb2ed4031f25.jpg";